document.addEventListener("DOMContentLoaded", function () {

  const input = document.getElementById("product-input");
  const suggestionsBox = document.getElementById("suggestions");
  const langSelect = document.getElementById("lang-select");
  const manualsWrapper = document.getElementById("manuals-wrapper");
  const emptyManuals = document.getElementById("manuals-empty");
  const productTitle = document.getElementById("product-title");

  let allManuals = {};
  let storedProductData = null;
  let selectedLang = langSelect?.value || "en";

  manualsWrapper.style.display = "none";
  emptyManuals.style.display = "none";

  /* FETCH API ONLY ONCE */

  fetch("https://dechbbrandcomstshrprd.blob.core.windows.net/product-documents/final-test")
    .then(res => res.json())
    .then(data => {
      allManuals = data;
    })
    .catch(err => {
      console.log("Fetch Error:", err);
    });

function formatProductTitle(handle) {

  return handle
    .replace(/-/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());

}
  /* SEARCH PRODUCTS (TITLE + HANDLE) */

  input.addEventListener("input", function (e) {

    const term = e.target.value.toLowerCase();
    suggestionsBox.innerHTML = "";
    manualsWrapper.style.display = "none";
    emptyManuals.style.display = "none";

    if (!term) return;
    const matches = Object.entries(allManuals).filter(([handle, product]) => {

  const title = (product.title || "").toLowerCase();
  const handleName = handle.toLowerCase();

  const searchTerm = term.replace(/\s+/g, "-");   
  const searchTermSpace = term.replace(/-/g, " ");

  const normalizedHandle = handleName.replace(/-/g, " "); 

  const isRefurbished =
    handleName.includes("refurb") ||
    handleName.includes("renewed") ||
    title.includes("refurb");

  if (isRefurbished) return false;

  return (
    title.includes(term) ||
    handleName.includes(term) ||
    handleName.includes(searchTerm) ||
    normalizedHandle.includes(searchTermSpace)
  );
});

    if (matches.length === 0) {
      suggestionsBox.innerHTML = `
        <li class="no-product">
          <span>No matching products found.</span>
        </li>
      `;
      return;
    }

    suggestionsBox.innerHTML = matches.map(([handle, product]) => {
  const title = product.title || formatProductTitle(handle);
  return `
    <li>
      <button type="button" class="suggestion-item" data-handle="${handle}">
        <h3>${title}</h3>
      </button>
    </li>
  `;
}).join("");
  });


  /* CLICK PRODUCT */

  suggestionsBox.addEventListener("click", function (e) {

    const button = e.target.closest(".suggestion-item");
    if (!button) return;
    const handle = button.dataset.handle;
    suggestionsBox.innerHTML = "";
    if (!allManuals[handle]) {
      manualsWrapper.style.display = "none";
      emptyManuals.style.display = "block";
      return;
    }

    storedProductData = allManuals[handle];
    if (!storedProductData || Object.keys(storedProductData).length === 0) {
      manualsWrapper.style.display = "none";
      emptyManuals.style.display = "block";
      return;
    }

    productTitle.textContent = storedProductData.title || formatProductTitle(handle);
    manualsWrapper.style.display = "block";
    emptyManuals.style.display = "none";
    renderAccordion();

  });


  /* LANGUAGE CHANGE */

  langSelect.addEventListener("change", function () {
    selectedLang = this.value
    if (storedProductData) {
      renderAccordion();
    }
  });


  /*NORMALIZE CATEGORY */

  function normalizeCategoryKey(rawTitle) {
    const lower = rawTitle.toLowerCase();
    if (titleTranslations["en"][rawTitle]) return rawTitle;
    if (lower.includes("declaration of conformity")) return "eu_conformity";
    if (lower.includes("instruction manual")) return "instruction_manual";
    if (lower.includes("manual")) return "instruction_manual";
    if (lower.includes("safety")) return "safety_instruction";
    if (lower.includes("compliance sheet")) return "compliance_sheet";
    if (lower.includes("compliance")) return "safety_instruction";
    if (lower.includes("faq")) return "faq_links";
    if (lower.includes("quick guide")) return "quick_guides";
    if (lower.includes("spec")) return "spec_sheets";
    if (lower.includes("fact")) return "fact_sheets";
    if (lower.includes("battery")) return "lithium_batteries_info";
    if (lower.includes("software")) return "application_software";
    if (lower.includes("photo")) return "high_resolution_photo";
    if (lower.includes("video")) return "how_to_videos";
    if (lower.includes("transport")) return "lithium_batteries_info";
    return "miscellaneous";
  }


  const titleTranslations = {
    en: {
      faq_links: "Links to FAQ pages",
      fact_sheets: "Fact Sheets",
      spec_sheets: "Spec Sheets",
      quick_guides: "Quick guides",
      eu_conformity: "EU Declaration of Conformity",
      how_to_videos: "How to videos",
      miscellaneous: "Miscellaneous",
      compliance_sheet: "Compliance Sheet",
      instruction_manual: "Instruction manual",
      safety_instruction: "Safety instructions and regulatory information",
      application_software: "Application Software",
      high_resolution_photo: "High resolution photo",
      lithium_batteries_info: "Transport information for Lithium-Ion batteries",
      manufacturer_declaration: "Manufacturer Declaration"
    },

    de: {
      faq_links: "Links zu FAQ-Seiten",
      quick_guides: "Kurzanleitungen",
      eu_conformity: "EU Konformitätserklärung",
      miscellaneous: "Sonstiges",
      instruction_manual: "Bedienungsanleitung",
      safety_instruction: "Sicherheitshinweise und rechtliche Informationen",
      lithium_batteries_info: "Transportinformationen für Lithium-Ionen-Batterien"
    },

    fr: {
      faq_links: "Liens vers foire aux questions",
      quick_guides: "Guides rapides",
      eu_conformity: "Déclaration de conformité UE",
      miscellaneous: "Divers",
      instruction_manual: "Notice d’emploi",
      safety_instruction: "Consignes de sécurité et informations réglementaires",
      lithium_batteries_info: "Informations de transport sur les batteries Lithium-Ion"
    },

    es: {
      faq_links: "Páginas de FAQ",
      quick_guides: "Guías rápidas",
      eu_conformity: "Declaración de conformidad de la UE",
      miscellaneous: "Varios",
      instruction_manual: "Instrucciones de manejo",
      safety_instruction: "Instrucciones de seguridad e información reglamentaria",
      lithium_batteries_info: "Información de transporte para baterías de iones de litio"
    },

    pt: {
      faq_links: "Páginas FAQ",
      quick_guides: "Guias rápidos",
      eu_conformity: "Declaração de conformidade da UE",
      miscellaneous: "Outros",
      instruction_manual: "Manual de instruções",
      safety_instruction: "Instruções de segurança e informações regulamentares",
      lithium_batteries_info: "Informação sobre o transporte de baterias de iões de lítio"
    },

    nl: {
      faq_links: "Links naar FAQ-pagina's",
      quick_guides: "Snelle gidsen",
      eu_conformity: "EU-conformiteitsverklaring",
      miscellaneous: "Diverse",
      instruction_manual: "Gebruiksaanwijzing",
      safety_instruction: "Veiligheidsinstructies en wettelijke informatie",
      lithium_batteries_info: "Transportinformatie voor lithium-ion-batterijen"
    },

    it: {
      faq_links: "Link alle pagine FAQ",
      quick_guides: "Guide rapide",
      eu_conformity: "Dichiarazione di conformità UE",
      miscellaneous: "Varie",
      instruction_manual: "Istruzioni per l’uso",
      safety_instruction: "Istruzioni di sicurezza e informazioni normative",
      lithium_batteries_info: "Informazioni sul trasporto delle batterie agli ioni di litio"
    },

    da: {
      faq_links: "Links til FAQ-sider",
      quick_guides: "Hurtige vejledninger",
      eu_conformity: "EU-overensstemmelseserklæring",
      miscellaneous: "Diverse",
      instruction_manual: "Betjeningsvejledning",
      safety_instruction: "Sikkerhedsanvisninger og lovgivningsmæssige oplysninger",
      lithium_batteries_info: "Transportoplysninger for litium-ion-batterier"
    },

    sv: {
      faq_links: "Länkar till FAQ-sidor",
      quick_guides: "Snabba guider",
      eu_conformity: "EU-försäkran om överensstämmelse",
      miscellaneous: "Diverse",
      instruction_manual: "Bruksanvisning",
      safety_instruction: "Sikkerhedsanvisninger og lovgivningsmæssige oplysninger",
      lithium_batteries_info: "Transportinformation för litiumjonbatterier"
    },

    fi: {
      faq_links: "Linkit FAQ-sivuille",
      quick_guides: "Pikaoppaat",
      eu_conformity: "EU:n vaatimustenmukaisuusvakuutus",
      miscellaneous: "Erilaiset",
      instruction_manual: "Käyttöohje",
      safety_instruction: "Turvallisuusohjeet ja sääntelyä koskevat tiedot",
      lithium_batteries_info: "Litiumioniakkuja koskevat kuljetustiedot"
    },

    el: {
      faq_links: "Σύνδεσμοι σε σελίδες FAQ",
      quick_guides: "Γρήγοροι οδηγοί",
      eu_conformity: "Δήλωση συμμόρφωσης ΕΕ",
      miscellaneous: "Διάφορα",
      instruction_manual: "Εγχειρίδιο οδηγιών",
      safety_instruction: "Οδηγίες ασφαλείας και κανονιστικές πληροφορίες",
      lithium_batteries_info: "Πληροφορίες μεταφοράς για μπαταρίες ιόντων λιθίου"
    },

    pl: {
      faq_links: "Linki do stron FAQ",
      quick_guides: "Skrócone instrukcje",
      eu_conformity: "Deklaracja zgodności UE",
      miscellaneous: "Różne",
      instruction_manual: "Instrukcja obsługi",
      safety_instruction: "Instrukcje bezpieczeństwa i informacje o przepisach prawnych",
      lithium_batteries_info: "Informacje dotyczące transportu baterii litowo-jonowych"
    },

    tr: {
      faq_links: "SSS sayfalarına bağlantılar",
      quick_guides: "Hızlı kılavuzlar",
      eu_conformity: "AB Uygunluk Beyanı",
      miscellaneous: "Çeşitli",
      instruction_manual: "Kullanım kılavuzu",
      safety_instruction: "Güvenlik talimatları ve düzenleyici bilgiler",
      lithium_batteries_info: "Lityum-İyon piller için taşıma bilgileri"
    },

    ru: {
      faq_links: "Ссылки на страницы с часто задаваемыми вопросами",
      quick_guides: "Краткие руководства",
      eu_conformity: "Декларация соответствия ЕС",
      miscellaneous: "Разное",
      instruction_manual: "Руководство по эксплуатации",
      safety_instruction: "Инструкции по безопасности и нормативная информация",
      lithium_batteries_info: "Информация о транспортировке литий-ионных батарей"
    },

    ja: {
      faq_links: "FAQページへのリンク",
      quick_guides: "クイックガイド",
      eu_conformity: "EU 適合性宣言",
      miscellaneous: "その他",
      instruction_manual: "取扱説明書",
      safety_instruction: "安全に関する指示と規制情報",
      lithium_batteries_info: "リチウムイオン電池の輸送情報"
    },

    zh_hans: {
      faq_links: "常见问题页面的链接",
      quick_guides: "快速指南",
      eu_conformity: "欧盟符合性声明",
      miscellaneous: "杂项",
      instruction_manual: "使用说明",
      safety_instruction: "安全指南",
      lithium_batteries_info: "锂离子电池运输信息"
    },

    zh_hant: {
      faq_links: "常見問題頁面的鏈接",
      quick_guides: "快速指南",
      eu_conformity: "歐盟符合性聲明",
      miscellaneous: "雜項",
      instruction_manual: "使用說明",
      safety_instruction: "安全指南",
      lithium_batteries_info: "鋰離子電池運輸信息"
    },

    ko: {
      faq_links: "자주 묻는 질문 페이지 링크",
      quick_guides: "퀵 가이드",
      eu_conformity: "EU 적합성 선언",
      miscellaneous: "기타",
      instruction_manual: "사용 설명서",
      safety_instruction: "안전 지침 및 규제 정보",
      lithium_batteries_info: "리튬 이온 배터리의 운송 정보"
    },

    id: {
      faq_links: "Tautan ke halaman FAQ",
      quick_guides: "Panduan cepat",
      eu_conformity: "Deklarasi Kesesuaian UE",
      miscellaneous: "Aneka ragam",
      instruction_manual: "Instruksi manual",
      safety_instruction: "Instruksi keselamatan dan informasi peraturan",
      lithium_batteries_info: "Informasi transportasi untuk baterai Litium-Ion"
    },

    cs: {
      faq_links: "Odkazy na stránky s nejčastějšími dotazy",
      quick_guides: "Rychlé průvodce",
      eu_conformity: "EU prohlášení o shodě",
      miscellaneous: "Různé",
      instruction_manual: "Návod k použití",
      safety_instruction: "Bezpečnostní pokyny a regulační informace",
      lithium_batteries_info: "Informace o přepravě lithium-iontových baterií"
    },

    sl: {
      faq_links: "Povezave do strani s pogostimi vprašanji",
      quick_guides: "Hitri vodniki",
      eu_conformity: "Izjava EU o skladnosti",
      miscellaneous: "Različni",
      instruction_manual: "Navodila za uporabo",
      safety_instruction: "Varnostna navodila in regulativne informacije",
      lithium_batteries_info: "Podatki o prevozu za litij-ionske baterije"
    }

  };

  /*RENDER ACCORDION */

  function renderAccordion() {

    if (!storedProductData || Object.keys(storedProductData).length === 0) {
      emptyManuals.style.display = "block";
      manualsWrapper.style.display = "none";
      return;
    }
    const accordion = document.getElementById("downloads-accordion");
    if (!accordion) return;
    accordion.innerHTML = "";
    const groupedData = {};
    Object.entries(storedProductData).forEach(([title, items]) => {
      if (!items || items.length === 0) return;
      const normalizedKey = normalizeCategoryKey(title);
      if (!groupedData[normalizedKey]) {
        groupedData[normalizedKey] = [];
      }
      groupedData[normalizedKey] =
        groupedData[normalizedKey].concat(items);
    });


    Object.entries(groupedData).forEach(([categoryKey, items]) => {
      const displayTitle =
        (titleTranslations[selectedLang] &&
          titleTranslations[selectedLang][categoryKey]) ||
        (titleTranslations["en"] &&
          titleTranslations["en"][categoryKey]) ||
        categoryKey;

      let linksHTML = "";

      items.forEach(item => {
        let url = item.defaultUrl;
        let label = item.label;

        if (item.translations && item.translations[selectedLang]) {
          url = item.translations[selectedLang].url;
          label = item.translations[selectedLang].label;
        }

        linksHTML += `
          <div class="faq-answer">
            <a target="_blank" href="${url}" rel="nofollow noopener noreferrer">
              ${label}
            </a>
          </div>
        `;
      });


      accordion.innerHTML += `
        <div class="accordion-item">
          <div class="accordion-heading">
            ${displayTitle}
            <em class="accordion-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 5">
                <path d="M.397.972a.479.479 0 0 1 .67-.684L4.5 3.658 7.932.288a.479.479 0 0 1 .671.684L4.5 5 .397.972Z"></path>
              </svg>
            </em>
          </div>
          <div class="accordion-content">
            ${linksHTML}
          </div>
        </div>
      `;

    });

    attachAccordionEvents();
  }


  /* ACCORDION EVENTS */

  function attachAccordionEvents() {
    const accordion = document.getElementById("downloads-accordion");
    if (!accordion) return;
    const headings = accordion.querySelectorAll(".accordion-heading");
    headings.forEach(heading => {
      heading.addEventListener("click", function () {
        const item = this.closest(".accordion-item");
        const content = item.querySelector(".accordion-content");
        const isOpen = item.classList.contains("active");
        accordion.querySelectorAll(".accordion-item").forEach(i => {
          i.classList.remove("active");
          $(i).find(".accordion-content").stop(true, true).slideUp();
        });
        if (!isOpen) {
          item.classList.add("active");
          $(content).stop(true, true).slideDown();
        }
      });
    });
  }
});